import React from "react";
import { Image, PixelRatio, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Icons } from "../../assets";

type Props = {
  caption?: string;
  value?: string;
  checked?: boolean;
  route?: string;
  color?: string;
  image: string;
  fontFamily?: string;
  fontSize?: number;
  onPress(route?: any): void;
};

const SelectionCard: React.FC<Props> = ({ caption = undefined, value = undefined, image, route = undefined, checked = false, color, fontFamily, fontSize, onPress }: Props): JSX.Element => {
  const cardFontFamily = fontFamily ? fontFamily : "Montserrat-Black";
  const cardFontSize = fontSize ? fontSize : 21;
  const hasCaption = Boolean(caption && caption.length > 0);
  const hasImage = Boolean(image);
  const hasValue = Boolean(value);
  const hasFooter = hasValue || checked;

  return (
    <TouchableOpacity style={[styles.card, { backgroundColor: color }]} activeOpacity={0.6} onPress={() => onPress(route ? route : undefined)}>
      {hasCaption && (
        <View style={styles.captionContainer}>
          <Text style={styles.caption}>{caption!.toUpperCase()}</Text>
        </View>
      )}
      {hasImage && (
        <View style={styles.imageContainer}>
          <Image source={typeof image === "number" ? image : { uri: image }} style={styles.image} />
        </View>
      )}
      {hasFooter && (
        <View style={styles.valueContainer}>
          <View style={styles.valueSlot}>
            {hasValue && <Text style={[styles.value, { color: color && "white", fontFamily: cardFontFamily, fontSize: cardFontSize }]}>{value!.toUpperCase()}</Text>}
          </View>
          {checked && (
            <View style={styles.checkmarkSlot}>
              <Image source={Icons.checkmarkIcon} style={styles.checkmark} />
            </View>
          )}
        </View>
      )}
    </TouchableOpacity>
  );
};

export default SelectionCard;

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#d1d3d4",
    opacity: 0.87,
    alignSelf: "flex-start",
    maxWidth: "40%",
    height: "90%",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRadius: 12 / PixelRatio.get(),
    marginLeft: "1%",
    marginRight: "1%",
    shadowColor: "#000",
    shadowOffset: { width: 6 / PixelRatio.get(), height: 6 / PixelRatio.get() },
    shadowOpacity: 0.16,
    shadowRadius: 4 / PixelRatio.get(),
    elevation: 1,
  },
  imageContainer: {
    width: "60%",
    flex: 6,
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "75%",
    resizeMode: "contain",
  },
  captionContainer: {
    flex: 1,
    marginTop: "4%",
    justifyContent: "center",
  },
  caption: {
    fontFamily: "Montserrat-SemiBold",
    fontSize: 18,
    color: "#3a3a3a",
  },
  valueContainer: {
    width: "100%",
    flex: 1.5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: "8%",
  },
  valueSlot: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  checkmarkSlot: {
    width: "20%",
    alignItems: "center",
    justifyContent: "center",
  },
  value: {
    fontFamily: "Montserrat-Black",
    fontSize: 21,
    fontWeight: "900",
    textAlign: "center",
    color: "#3a3a3a",
    width: "60%",
  },
  checkmark: {
    maxHeight: 50 / PixelRatio.get(),
    resizeMode: "contain",
  },
});
